/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Add_Issue_LabelInputs */



/**
* | output |
* | --- |
* | "Add new issue" |
*
* @param {Manual_Qc_Add_Issue_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_add_issue_label = /** @type {((inputs?: Manual_Qc_Add_Issue_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Add_Issue_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un incident")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Problem hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi un nuovo problema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить новый выпуск")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir nuevo problema")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加新问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい問題を追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया मुद्दा जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar novo problema")
	return /** @type {LocalizedString} */ ("Add new issue")
});